<template>
  <div
    class="ah-picture"
    :style="{ width: w ? w : '', height: h ? h : '' }"
  >
    <picture v-if="isMediaPic && picturesMedia">
      <source
        v-for="(picmedia, index) in picturesMedia" 
        :key="index"
        :srcset="src+':'+picmedia.ratio+'?fmt='+picmedia.fmt+'&op_usm=1.75,0.3,2,0&resMode=sharp2&iccEmbed=true&icc=sRGB&dpr=on,1&wid='+picmedia.wid+'&hei='+picmedia.hei+'&qlt=80'"
        :media="picmedia.media" 
        type="image/webp"
      >
      <img
        :alt="alt"
        :src="src+':'+picturesMedia[0].ratio || '16by9'+'?fmt=jpg&op_usm=1.75,0.3,2,0&resMode=sharp2&iccEmbed=true&icc=sRGB&dpr=on,1&wid='+picturesMedia[0].wid || '335'+'&hei='+picturesMedia[0].wid || '335'+'&qlt=80'"
        :loading="loading"
        :data-src="dataSrc"
        class="ah-picture__img"
        @load="loadedHandler"
      >
    </picture>
    <img
      v-else
      :alt="alt"
      :src="srcImage"
      :loading="loading"
      :data-src="dataSrc"
      class="ah-picture__img"
      @load="loadedHandler"
    >
  </div>
</template>
<script>
  export default {
    name: 'AhPicture',
    inject: {
      prerendering: {
        default: false
      },
    },
    props: {
      src: { type: String, required: true },
      alt: { type: String, default: ' ' },
      w: { type: String, default: '' },
      h: { type: String, default: '' },
      isMediaPic: {
        type: Boolean,
        default: false
      },
      picturesMedia: {
        type: Array,
        default: () => ([])
      },
      loading: {
        type: String,
        default: 'lazy',
        validator: (value) => ['', 'lazy', 'eager'].includes(value),
      },
      placeholder: {
        type: String,
        default: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNjYgMjY2Ij4KICA8cGF0aCBkPSJNMjU4LDI2NS42SDE5MS4zbC00MS45LTk3LjRjLTI0LjUsMTMuMy0zOC42LDQ0LTYzLjQsNjQuNGExNDcuODMzODYsMTQ3LjgzMzg2LDAsMCwxLTQ1LjksMjUuOWMtOC40LDIuOC0yMi42LDYuNS0yNy45LDctMi4zLjItMy44LjktNC4xLjEtLjItLjYuMy0xLjgsMi43LTMsMi43LTEuMywxMy45LTYsMjEtMTAuOCw4LjgtNi4yLDEzLjgtMTIuOCwxNC4yLTE3LjktMi40LTguNC0xOS43LTI3LjMtMi4xLTYxLjgsNi4zLTEyLjQsMTEuNy0yMS4zLDE1LjYtMzAuMyw0LjUtMTAuMyw3LjctMjQuOCw4LjgtMzUuNi4xLS42LjItLjYuNS0uMiw4LjYsOC43LDQxLjgsNDIuNiwzNi45LDc2LjUsMTEuMS00LjIsMzAuMi0xNy4xLDM5LTIzLjksOS4zLTcuMywxNS40LTE0LjcsMjUuMy0xNC45LDguOC0uMSw5LjYsNC4xLDE2LjYsNWExMS43NzUyMSwxMS43NzUyMSwwLDAsMCw1LjYtLjhjLjUtLjIuNC0uOS0uNC0xLjEtOS42LTIuMy0xMS45LTEwLjEtMjQuMy0xMC4xLTExLjEsMC0yMCwxMC4yLTI2LjQsMTQuNEwxMDkuOCw4NmMtMTMtMjcuMy04LjUtNDcuMSwyMC40LTg2WiIgZmlsbD0iI2RmZGZlMSIvPgo8L3N2Zz4K',
      }
    },
    data () {
      return {
        loaded: false,
        srcImage: this.prerendering ? '/imagerie/px.gif' : this.placeholder,
      };
    },
    computed: {
      dataSrc() {
        return this.prerendering ? this.src : null;
      },
    },
    methods: {
      loadedHandler () {
        this.loaded = true;
        this.srcImage = this.prerendering ? '/imagerie/px.gif' : this.src;
        this.$emit('img:loaded');
      }
    },

  };
</script>
